<template>
  <div class="simple-tooltip-wrapper" @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <slot></slot>
    <div 
      v-if="visible" 
      class="simple-tooltip"
      :class="[`tooltip-${placement}`]"
    >
      {{ content }}
      <div class="tooltip-arrow" :class="[`arrow-${placement}`]"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleTooltip',
  props: {
    content: {
      type: String,
      required: true
    },
    placement: {
      type: String,
      default: 'bottom',
      validator: (value) => ['top', 'bottom', 'left', 'right'].includes(value)
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    showTooltip() {
      this.visible = true
    },
    hideTooltip() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.simple-tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.simple-tooltip {
  position: absolute;
  z-index: 10000;
  background: #444444;
  color: white;
  border-radius: 4px;
  padding: 8px 10px;
  font-size: 12px;
  max-width: 250px;
  width: 250px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tooltip-bottom {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 5px;
}

.tooltip-top {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 5px;
}

.tooltip-left {
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 5px;
}

.tooltip-right {
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 5px;
}

.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
}

.arrow-bottom {
  border-width: 0 5px 5px 5px;
  border-color: transparent transparent #444444 transparent;
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
}

.arrow-top {
  border-width: 5px 5px 0 5px;
  border-color: #444444 transparent transparent transparent;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
}

.arrow-left {
  border-width: 5px 0 5px 5px;
  border-color: transparent transparent transparent #444444;
  right: -5px;
  top: 50%;
  transform: translateY(-50%);
}

.arrow-right {
  border-width: 5px 5px 5px 0;
  border-color: transparent #444444 transparent transparent;
  left: -5px;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// SimpleTooltip.vue?5531977b